import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "step step-3" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "explanation" }, [
    /*#__PURE__*/ _createTextVNode("Uppgifter markerade med en röd stjärna ("),
    /*#__PURE__*/ _createElementVNode("span", null, "*"),
    /*#__PURE__*/ _createTextVNode(") måste anges för att du skall kunna gå vidare till nästa steg")
], -1);
const _hoisted_3 = { class: "group accommodation" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "group-title" }, [
    /*#__PURE__*/ _createTextVNode("Sökande"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_6 = ["value", "id"];
const _hoisted_7 = ["for"];
const _hoisted_8 = { key: 0 };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "group-title" }, [
    /*#__PURE__*/ _createTextVNode("Medsökande"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_10 = ["value", "id"];
const _hoisted_11 = ["for"];
const _hoisted_12 = { class: "buttons" };
const _hoisted_13 = { class: "flex" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-arrow" }, null, -1);
const _hoisted_15 = { class: "link-title" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-arrow-rotate-left" }, null, -1);
const _hoisted_17 = { class: "link-title" };
const _hoisted_18 = ["disabled"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'Step3',
    props: {
        calc: {},
        props: {}
    },
    setup(__props) {
        const p = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                            _hoisted_5,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.calc.Accommodation), (key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (_ctx.calc.is.optionAvailable.applicantAccommodation(key))
                                        ? (_openBlock(), _createElementBlock("p", {
                                            class: "radio",
                                            key: key
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                value: _ctx.calc.Accommodation[key],
                                                id: `accommodation-${key}`,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.calc.applicant.accommodation) = $event)),
                                                name: "accommodation"
                                            }, null, 8, _hoisted_6), [
                                                [_vModelRadio, _ctx.calc.applicant.accommodation]
                                            ]),
                                            _createElementVNode("label", {
                                                for: `accommodation-${key}`
                                            }, _toDisplayString(_ctx.calc.Accommodation[key].label), 9, _hoisted_7)
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 256))
                        ]),
                        (_ctx.calc.is.caringForBoth() && !_ctx.calc.is.domesticCare())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _hoisted_9,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.calc.Accommodation), (key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (_ctx.calc.is.optionAvailable.coApplicantAccommodation(key))
                                            ? (_openBlock(), _createElementBlock("p", {
                                                class: "radio",
                                                key: key
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    value: _ctx.calc.Accommodation[key],
                                                    id: `accommodation-second-${key}`,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.calc.coApplicant.accommodation) = $event)),
                                                    name: "accommodation-co"
                                                }, null, 8, _hoisted_10), [
                                                    [_vModelRadio, _ctx.calc.coApplicant.accommodation]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: `accommodation-second-${key}`
                                                }, _toDisplayString(_ctx.calc.Accommodation[key].label), 9, _hoisted_11)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", {
                            class: "link linkIcon",
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.calc.gotoStep(_ctx.calc.Step.TypeOfService, true)))
                        }, [
                            _hoisted_14,
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.calc.ButtonStrings.back), 1)
                        ]),
                        _createElementVNode("button", {
                            class: "link linkIcon",
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.calc.resetForm()))
                        }, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.calc.ButtonStrings.reset), 1)
                        ])
                    ]),
                    _createElementVNode("button", {
                        class: "themeButton",
                        disabled: _ctx.calc.is.unfulfilled.accommodation(),
                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.calc.gotoStep(_ctx.calc.Step.IncomeAndExpenditure)))
                    }, _toDisplayString(_ctx.calc.ButtonStrings.next), 9, _hoisted_18)
                ])
            ]));
        };
    }
});
